module.exports = __webpack_public_path__ + "tempal-icons.d124604c6b4c128758e6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/tempal-icons/tempal-icons.eot?c8otwj
// module id = 158
// module chunks = 5